// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/yxyweb/common/components/picturebook/PictureBook.less
// module id = 1085
// module chunks = 0